export const CUSTOM_EXPORT_TO_EXCEL_COLUMNS = [
  { row_number: "#" },
  { creation_date: "Created At" },
  { means_of_transportation: "TC" },
  { cmr: "CMR" },
  { customs_code_and_office_name: "Departure - Destination" },
  { consignment_items: "TNVED" },
  { warranty: "Warranty" },
  { guarantee_cost: "Warranty Cost" },
  { one_code: "1th Code" },
  { next_code: "Next Code" },
  { epi_cost: "EPI Cost" },
  { total_cost: "Total Cost" },
];
